import React from 'react';
import styled from 'styled-components';

import AiProducerIcon from '../../svgs/AiProducerIcon';

type Props = {
  handleClick: () => void;
  text: string;
  Icon?: React.ReactNode;
  strokeColor?: string;
  unsetWidth?: boolean;
  disabled?: boolean;
};
const AIGenerateCard = (props: Props) => {
  const {
    Icon = (
      <AiProducerIcon
        strokeColor={props.strokeColor || 'currentColor'}
        width="14"
        height="14"
        viewBox="0 0 22 20"
      />
    ),
    text,
    handleClick,
    disabled = false,
  } = props;
  return (
    <Card
      onClick={handleClick}
      unsetWidth={props.unsetWidth}
      disabled={disabled}
    >
      {Icon}
      {text}
    </Card>
  );
};

export default AIGenerateCard;

const Card = styled.button<{ unsetWidth?: boolean }>`
  display: flex;
  width: ${props => (props.unsetWidth ? 'unset' : 'auto')};
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: var(--radius);
  border: none;
  background: transparent;
  color: var(--foreground);
  font-family: var(--font-primary);
  font-size: var(--text-xs);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  transition: all 150ms ease-out;

  &:hover {
    background-color: var(--surface-elevated);
  }

  &:active {
    background-color: var(--gray-700);
    scale: 0.98;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
`;
